import { USER_PERMISSIONS } from "dyl-components";
import { BillingOverview } from "pages";
import BillingContacts from "pages/BillingContacts";
import PaymentMethods from "pages/PaymentMethods";
import TransactionHistory from "pages/TransactionHistory";
import React from "react";
import { Route } from "react-router-dom";
import RestrictedView from "shared/RestrictedView";

export const BILLING_ROUTES = [
    <Route
        index
        path="overview"
        element={
            <RestrictedView
                type="restricted"
                userPermission={USER_PERMISSIONS.BILLING_VIEW}
            >
                <BillingOverview />
            </RestrictedView>
        }
    />,
    <Route
        index
        path="transaction-history"
        element={
            <RestrictedView
                type="restricted"
                userPermission={USER_PERMISSIONS.BILLING_VIEW}
            >
                <TransactionHistory />
            </RestrictedView>
        }
    />,
    <Route
        index
        path="payment-method"
        element={
            <RestrictedView
                type="restricted"
                userPermission={USER_PERMISSIONS.BILLING_VIEW}
            >
                {" "}
                <PaymentMethods />
            </RestrictedView>
        }
    />,
    <Route
        index
        path="billing-contacts"
        element={
            <RestrictedView
                type="restricted"
                userPermission={USER_PERMISSIONS.BILLING_VIEW}
            >
                <BillingContacts />
            </RestrictedView>
        }
    />,
];
